<template>
  <v-dialog :value="dialogProp.show" persistent max-width="600">
    <v-card class="elevation-12">
      <v-toolbar dark color="primary" class="textwithbackground--text">
        <v-toolbar-title>
          {{ $t('Редактирование записи справочника Базис поставки') }}
        </v-toolbar-title>
      </v-toolbar>
      <v-row v-if="!!generalError || isLoading" class="my-0 py-0 mx-1">
        <v-col v-if="isLoading" cols="12">
          <v-progress-linear :active="isLoading" color="loader" indeterminate />
        </v-col>
        <v-col v-if="!!generalError" class="mx-1">
          <general-error v-if="!!generalError" />
        </v-col>
      </v-row>
      <v-card-text class="pt-3">
        <ValidationObserver ref="item" @keydown.native.enter="focusOnBtn('continueBtn')">

          <validatable-text-input
              v-model="item.descriptionRu"
              rules="required"
              :readonly="isLoading"
              :label="$t('Описание (RU)')" />

          <validatable-text-input
              v-model="item.descriptionEn"
              rules="required"
              :readonly="isLoading"
              :label="$t('Описание (EN)')" />

          <validatable-text-input
              v-model="item.shippingCost"
              :rules="{ required: true,
                        regex: /^[0-9]{1,11}([.][0-9]{0,2})?$/ }"
              :readonly="isLoading"
              :label="$t('Расходы продавца по доставке покупателю')"
              data-type="float" />

        </ValidationObserver>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
            id="cancelBtn"
            v-test="{ btn: 'cancel' }"
            color="primary"
            @click.stop="cancel">
          {{ $t('Отмена') }}
        </v-btn>
        <v-btn
            id="continueBtn"
            v-test="{ btn: 'continue' }"
            color="primary"
            :disabled="isLoading"
            @click.stop="continueOperation">
          {{ $t('Сохранить') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import ValidatableTextInput from '@/components/reused/ui/ValidatableTextInput.vue'

  export default {
    components: {
      ValidatableTextInput,
      GeneralError
    },
    props: {
      dialogProp: {
        type: Object,
        default: () => {
          return {
            item: null,
            show: false,
            callback: null
          }
        }
      }
    },
    data () {
      return {
        isLoading: false,
        item: {
          deliveryBasisRevisionId: null,
          shippingCost: null,
          descriptionRu: null,
          descriptionEn: null
        }
      }
    },
    computed: {

    },
    created () {
      this.mapFields(this.dialogProp.item)
    },
    beforeDestroy () {
      this.clearStore()
    },
    methods: {
      clearStore: async function () {
        return Promise.all(
          [
          ])
      },
      getDeliveryBasisInfo: async function () {
        try {
          this.isLoading = true
          await this.getDeliveryBasisInfoAction({
            id: this.dialogProp.id
          })
          this.isLoading = false
          this.mapFields(this.current)
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      mapFields: function (item) {
        if (!item) {
          return
        }

        this.item.deliveryBasisRevisionId = item.deliveryBasisRevisionId
        this.item.shippingCost = item.shippingCost
        this.item.descriptionRu = item.descriptionRu
        this.item.descriptionEn = item.descriptionEn
      },
      continueOperation: async function () {
        try {
          const result = await this.$refs.item.validate()
          if (!result) {
            return
          }
          this.isLoading = true

          if (this.dialogProp.callback) {
            await this.dialogProp.callback(this.item)
          }
          this.isLoading = false
          this.cancel()
        } catch (error) {
          this.isLoading = false
          this.throwIfUnknownError(error)
          // проверка или сохранение формы неуспешно, остаемся в диалоговом окне
        }
      },
      cancel: function () {
        this.$emit('close')
      }
    }
  }
</script>
